/**
 * Residential types are listed rather than excluded.
 *
 * The rule used to name the commercial types and treat everything else as
 * housing, so adding a type made it exempt under пп.10 п.3 ст.149 by default —
 * retail and a warehouse would each have arrived at 0% without anyone deciding
 * that. Listing the three that are actually homes makes a new type commercial
 * until someone says otherwise, which is the answer that gets reviewed rather
 * than the one that slips through.
 */
const RESIDENTIAL_TYPES = new Set(["APARTMENT", "HOUSE", "ROOM"]);
export function isResidential({ propertyType, housingType, }) {
    if (!RESIDENTIAL_TYPES.has(propertyType))
        return false;
    // Апартаменты юридически нежилые, хотя живут в них.
    if (propertyType === "APARTMENT" && housingType === "APARTMENTS") {
        return false;
    }
    return true;
}
